import React from 'react';
import Settings from '../Settings';
import { useAuth } from '../AuthProvider';
import Login from '../Login';
import { useNavigate } from 'react-router-dom';
import PageWrapperAuto from '../components/PageWrapperAuto';
import { useUI } from '../UIContext';

export default function SettingsPage() {
  const { inputStyle, textStyle } = useUI();
  const { user, logOut } = useAuth();
  const navigate = useNavigate();

  if (!user) return (
    <PageWrapperAuto>
      <Login />
    </PageWrapperAuto>
  );

  return (
    <PageWrapperAuto>
<Settings onBack={() => navigate(-1)} />

<div style={{ maxWidth: '240px', margin: '0px auto' }}>
  <button onClick={logOut} style={{ ...inputStyle, width: '100%' }}>
    Log Out
  </button>

  
</div>

    </PageWrapperAuto>
  );
}